import styled from '@emotion/styled';
import React from 'react';
import Link from 'next/link';
import { fontFrame } from '../../../../styles/mixin/font';
import { BLACK, DARK_GRAY, LIGHT_BLUE } from '../../../../styles/constants/color';
import ScFacebook from '../../icon/ScFacebook';
import ScGooglePlaystore from '../../icon/ScGooglePlaystore';
import ScInquiry from '../../icon/ScInquiry';
import ScYoutube from '../../icon/ScYoutube';
import ScBlog from '../../icon/ScBlog';
import ScInstagram from '../../icon/ScInstagram';
import Span from '../../text/Span';

const Base = styled.div`
  display: grid;
  grid-template-columns: 90px 140px;
  width: 100%;
  height: auto;
  padding: 30px 20px;
`;

const Ul = styled.ul<{ padding?: boolean }>`
  width: auto;
  height: auto;
  padding-left: ${props => props.padding && '20px'};
`;

const Li = styled.li`
  width: auto;
  height: auto;
  margin-bottom: 16px;

  &:last-of-type {
    margin-bottom: 0;
  }
`;

const Button = styled.button`
  width: auto;
  height: auto;
  text-align: center;
`;

const GroupNameSpan = styled.span<{ active: boolean }>`
  display: block;
  width: 90px;
  ${fontFrame('400', '15px', '1', DARK_GRAY)};
  color: ${props => props.active && LIGHT_BLUE};
  border-right: ${props => props.active && `2px solid ${LIGHT_BLUE}`};
  text-align: left;
`;

// const ItemSpan = styled.span`
//   ${fontFrame('400', '15px', '1', BLACK)}
// `;

const ButtonBase = styled.div`
  display: grid;
  width: 100%;
  height: 100%;
  padding-right: 10px;
  grid-template-columns: repeat(2, 1fr);
`;

interface Props {
  groupNameList: any[];
  itemList: any[];
  clickGroupNameEvent: (name: string) => void;
  openVideo: () => void;
  openCalculator: () => void;
  closeEvent: () => void;
}

/**
 *  pc화면에서의 네비게이션 목록 컴포넌트
 * @param {any[]} groupNameList 네비게이션 대제목 목록
 * @param {any[]} itemList 네비게이션 목록
 * @param {function} clickGroupNameEvent 대제목 클릭 함수
 * @param {function} openVideo 비디오 열기 함수
 * @param {function} openCalculator 할부계산기 열기 함수
 * @param {function} closeEvent 네비게이션 비활성화 클릭 함수
 *  */
function NavigationBodyMobileContents({
  groupNameList,
  itemList,
  clickGroupNameEvent,
  openVideo,
  openCalculator,
  closeEvent,
}: Props): JSX.Element {
  return (
    <Base>
      <Ul>
        {groupNameList.map((group: GroupName) => (
          <Li key={group.name}>
            <Button onClick={() => clickGroupNameEvent(group.name)}>
              <GroupNameSpan active={group.active}>{group.name}</GroupNameSpan>
            </Button>
          </Li>
        ))}
        <Li>
          <ButtonBase>
            <ScFacebook />
            <ScYoutube />
            <ScBlog />
            <ScInstagram />
            <ScInquiry />
            <ScGooglePlaystore />
          </ButtonBase>
        </Li>
      </Ul>
      <Ul padding>
        {itemList
          .filter((item: Item) => item.group === groupNameList.find(group => group.active)?.name)
          .map((item: Item) => (
            <Li key={item.name}>
              {item.href && (
                <Link href={item.href} onClick={closeEvent} passHref>
                  <Span fontSize='15px' color={item.active ? LIGHT_BLUE : BLACK}>
                    {item.name}
                  </Span>
                </Link>
              )}
              {item.action && (
                <Button
                  onClick={() => {
                    item.action === 'calculator' ? openCalculator() : openVideo();
                  }}
                >
                  <Span fontSize='15px' color={item.active ? LIGHT_BLUE : BLACK}>
                    {item.name}
                  </Span>
                </Button>
              )}
            </Li>
          ))}
      </Ul>
    </Base>
  );
}

interface GroupName {
  name: string;
  active: boolean;
}

interface Item {
  name: string;
  group: string;
  href?: string;
  action?: string;
  active: boolean;
}

export default NavigationBodyMobileContents;
